export default function (context, value) {
    context.dispatch('settings/open', 'invoices', {root: true});
}